// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//引入vuex仓库
import store from './vuex'
//引入elementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';

Vue.use(ElementUI)
//引入layer弹窗
import layer from 'vue-layer'
Vue.prototype.$layer = layer(Vue);
//引如样式重置
import '../static/css/reset.css'

import '../static/css/buttons.css'
/*
 * 饿了么UI折叠特效
 */
import 'element-ui/lib/theme-chalk/base.css'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
Vue.component(CollapseTransition.name, CollapseTransition)

/*
 * 复制到剪切板
 */
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
//引入axios
import axios from './tools/http.js'
Vue.prototype.$ajax = axios;
//引入cookie
import VueCookie from 'vue-cookies'
Vue.use(VueCookie)
//二维码
import VueQriously from 'vue-qriously';
Vue.use(VueQriously);
/*
 * 接口地址
 */
if (process.env.NODE_ENV=='development') {
  //调试模式
  global.url = 'https://boat3.qqplugin.com/index.php'
} else {
  //线上版本
  global.url = '/index.php'
}

/*
 * 初始化
 */
new Vue({
  el: '#app',
  data() {
    return {}
  },
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  beforeCreate: function() {

  }
})



// WEBPACK FOOTER //
// ./src/main.js